<script>

    export let address;
    export let city;
    export let state;

</script>

<!-- <svelte:head>
	<script defer async
	src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBlX45uDec1JpI_nlqac_tV0HIWqivY-9E&callback=initMap">
	</script>
</svelte:head>
 -->


<iframe title="location map" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBlX45uDec1JpI_nlqac_tV0HIWqivY-9E&q={address}, {city} {state}#/">
</iframe>

<style>

    iframe {
        width: 100%;
        height: 90%;
    }

</style>